<template>
  <div class="box-card">
        <div class="box-userface">
          <img v-if="isLoad" style="
              background: white;
              height: 80px;
              width: 80px;
              border: 1px solid #c0c0c0;
              border-radius: 50%;"
               :src="avatarUrl || require('../assets/img/logo.png')"
               alt="头像"
               @error="handleAvatarError">
          <div class="userlable">{{ userInfo && userInfo.realName ? userInfo.realName : '未登录' }}</div>
        </div>
    <div class="cardBody">
      <div class="userinfolsit" v-if="getUserTypeName()">用户类型：
        <div style="font-weight: 500">
          {{ getUserTypeName() }}
        </div>
      </div>
      <div class="userinfolsit" >所属科室：
        <div style="font-weight: 500">
          {{ userDept.deptName || '中医内科'}}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getBlob } from '@/api/api'

export default {
  data() {
    return {
      isLoad: false,
      userInfo: {},
      userTypeList: [
        {
          id: 1,
          name: '医院管理员'
        },
        {
          id: 2,
          name: '挂号收费员'
        },
        {
          id: 3,
          name: '门诊医生'
        },
        {
          id: 4,
          name: '医技医生'
        },
        {
          id: 5,
          name: '药房操作员'
        },
        {
          id: 6,
          name: '财务管理员'
        },
      ],
      userDept: {},
      avatarUrl: '',
      avatarBlob: null
    }
  },
  methods: {
    /**
     * 获取当前操作员
     * @returns {any}
     */
    getCurrentUser() {
      return JSON.parse(sessionStorage.getItem("User"))
    },

    /**
     * 设置当前操作员
     * @returns {Promise<void>}
     */
    async setCurrentUser() {
      this.userInfo = this.getCurrentUser()
      this.getAvatarThumbnail()

      // const resp = await this.$axios.get(`/queryUserDeptByID?DeptID=${this.userInfo.deptID}`)
      // this.userDept = resp.data.data
    },

    getUserTypeName() {
     switch (this.userInfo.userLevel) {
       case 1:
          return '运营端'
         break;
       case 2:
         return '机构端（管理员）'
         break;
       case 3:
         return '医生端'
         break;
     }
    },
    
    /**
     * 获取用户头像缩略图（与UserCenter.vue一致）
     */
    getAvatarThumbnail() {
      // 导入api中的getBlob方法
      const { getBlob } = require('@/api/api')
      // 先释放之前的Blob URL，防止内存泄漏
      if (this.avatarUrl) {
        URL.revokeObjectURL(this.avatarUrl)
        this.avatarUrl = ''
      }
      // 添加时间戳参数避免缓存
      getBlob(`/personalCenter/thumbnail?t=${Date.now()}`).then(res => {
        // 创建Blob URL
        const blob = new Blob([res.data], { type: res.headers['content-type'] })
        this.avatarUrl = URL.createObjectURL(blob)
        this.isLoad = true
      }).catch(err => {
        console.error('获取头像失败:', err)
      })
    },
    
    /**
     * 处理头像加载错误
     */
    handleAvatarError() {
      this.avatarUrl = require('../assets/img/logo.png')
    }
  },
  created() {
    this.setCurrentUser()
  },
  beforeDestroy() {
    // 组件销毁前释放blob URL，防止内存泄漏
    if (this.avatarUrl && this.avatarUrl.startsWith('blob:')) {
      URL.revokeObjectURL(this.avatarUrl)
    }
  }
}
</script>

<style lang="less" scoped>
.box-card {
  height: 100%;
  width: 20rem;
  background-color: #f5f7f9;
  border-radius: 20px;
  box-shadow: 0px 3px 7px 0px rgb(0 0 0 / 50%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  .box-userface{
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 10px;
    margin-top: -35px;
    border-bottom: 2px solid #96bfef;
    padding-bottom: 15px;
  }
}

.userlable {
  color: rgba(0,0,0,.5);
  font-size: 20px;
  font-weight: 700;
}
.cardBody {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  .userinfolsit {
    color: rgba(0, 0, 0, .5);
    font-weight: 700;
    display: flex;
    align-items: center;
    border-radius: 20px;
    text-align: left;
    position: relative;
    left: 26%;
    .box-userface {
      padding-bottom: 20px;
      border-bottom: 2px solid #96bfef;
    }
  }
}
</style>